export type Product = {
    readonly edition: string | null | undefined;
    readonly imgSource: string | null | undefined;
    readonly product: string | null;
    readonly serverDownloadContent: string | null | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly productContent?: any[] | null | undefined;
};
